import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

import {
  Grid,
  Typography,
  Button,
  MenuItem,
  CircularProgress,
} from '@material-ui/core';

import { useStyles } from './styles.js';

class ButtonGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const classes = this.props.classes;
    const index = this.props.index;

    return (
      <div className={classes.cardActionBtn}>
        {this.props.last_tab ? (
          <div className={classes.cardActionBtn}>
            <Button
              color="primary"
              type="button"
              variant="contained"
              onClick={() => {
                this.props.onDiscardDilogOpen();
              }}
            >
              Back To All Games
            </Button>

            <Button
              color="default"
              type="button"
              variant="contained"
              onClick={() => {
                index > 0
                  ? this.props.onActiveTabChange(index)
                  : this.props.onTabChange();
              }}
              className={classes.backButton}
            >
              Back
            </Button>

            <Button
              color="primary"
              type="submit"
              variant="contained"
              onClick={e => {
                this.props.onSubmit();
              }}
              disabled={this.props.isSubmitted}
            >
              Submit
            </Button>

            {this.props.isSubmitted ? (
              <CircularProgress
                color="secondary"
                size={22}
                className={classes.buttonProgress}
              />
            ) : null}
          </div>
        ) : (
          <div className={classes.cardActionBtn}>
            <Button
              color="primary"
              type="button"
              variant="contained"
              onClick={() => {
                this.props.onDiscardDilogOpen();
              }}
            >
              Back To All Games
            </Button>
            <Button
              color="default"
              type="button"
              variant="contained"
              onClick={() => {
                index > 0
                  ? this.props.onActiveTabChange(index)
                  : this.props.onTabChange();
              }}
              className={classes.backButton}
            >
              Back
            </Button>

            <Button
              color="primary"
              type="button"
              variant="contained"
              onClick={this.props.nextQuarterClick(`quarter${index + 2}`)}
            >
              Next
            </Button>
          </div>
        )}
      </div>
    );
  }
}

ButtonGroup.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(ButtonGroup);
